import { get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';

const definitions = Definitions.Sample;

const callGet = async (requestParams: {
  filter: string;
}): Promise<IFinalResponse> => {
  const init: InitApiType = {
    params: {
      filter: requestParams.filter,
    },
  };

  return get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

/**
 * Para outros métodos:
 * callPost
 * callPut
 * callDelete
 * */
const call = { get: callGet };

export default { call, definitions };
